import type { QueryClient, QueryKey } from '@tanstack/react-query'

export function optimisticUpdate<TData, TVariables>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  update: (current: TData, variables: TVariables) => TData,
) {
  return {
    mutationKey: queryKey,
    onMutate: async (variables: TVariables) => {
      await queryClient.cancelQueries({ queryKey })
      const previous = queryClient.getQueryData<TData>(queryKey)
      if (previous !== undefined) {
        queryClient.setQueryData<TData>(queryKey, update(previous, variables))
      }
      return { previous }
    },
    onError: (_error: unknown, _variables: TVariables, context?: { previous?: TData }) => {
      if (context?.previous !== undefined) {
        queryClient.setQueryData<TData>(queryKey, context.previous)
      }
    },
    onSettled: () => {
      if (queryClient.isMutating({ mutationKey: queryKey }) === 1) {
        return queryClient.invalidateQueries({ queryKey })
      }
    },
  }
}
